// Fonction pour parser les horaires (ex: "10h - 18h", "10h-18h", "9h30-16h30")
function parseHours(hoursString) {
    if (!hoursString || hoursString.toLowerCase().includes('fermé') || hoursString.toLowerCase().includes('ferme')) {
        return null;
    }

    // Regex pour capturer les heures avec ou sans minutes
    // Match patterns like: "9h30-16h30", "9h-16h", "9:30-16:30"
    const match = hoursString.match(/(\d{1,2})[h:]\s*(\d{0,2})\s*-\s*(\d{1,2})[h:]\s*(\d{0,2})/);
    if (match) {
        const openHour = parseInt(match[1]);
        const openMin = match[2] ? parseInt(match[2]) : 0;
        const closeHour = parseInt(match[3]);
        const closeMin = match[4] ? parseInt(match[4]) : 0;

        return {
            open: openHour * 60 + openMin, // Convertir en minutes totales
            close: closeHour * 60 + closeMin
        };
    }
    return null;
}

// Fonction pour vérifier si un store est ouvert
function isStoreOpen(storeElement) {
    const now = new Date();
    const dayOfWeek = now.getDay(); // Dimanche = 0, Lundi = 1, ..., Samedi = 6

    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTimeInMinutes = currentHour * 60 + currentMinutes;

    // Récupérer les horaires du jour
    let todayHours;
    switch(dayOfWeek) {
        case 0: todayHours = storeElement.dataset.hoursDimanche; break;
        case 1: todayHours = storeElement.dataset.hoursLundi; break;
        case 2: todayHours = storeElement.dataset.hoursMardi; break;
        case 3: todayHours = storeElement.dataset.hoursMercredi; break;
        case 4: todayHours = storeElement.dataset.hoursJeudi; break;
        case 5: todayHours = storeElement.dataset.hoursVendredi; break;
        case 6: todayHours = storeElement.dataset.hoursSamedi; break;
    }

    const hours = parseHours(todayHours);
    if (!hours) {
        return false; // Fermé
    }

    // hours.open et hours.close sont déjà en minutes totales
    return currentTimeInMinutes >= hours.open && currentTimeInMinutes < hours.close;
}

// Vérification des horaires d'ouverture
document.addEventListener('DOMContentLoaded', function() {
    var storeInfos = document.querySelectorAll('.mm-modal-shop-infos');

    storeInfos.forEach(function(storeInfo) {
        var shopOpenHour = storeInfo.querySelector('.mm-modale-shop-open-hour');
        var openTime = storeInfo.querySelector('.mm-modale-store-open');
        var closeTime = storeInfo.querySelector('.mm-modale-store-close');
        var dot = storeInfo.querySelector('.shop-modal-dot');
        var telWrapper = storeInfo.querySelector('.mm-modal-shop-tel-wrapper');
        var closedText = storeInfo.querySelector('.mm-modal-shop-closed-text');

        if (isStoreOpen(storeInfo)) {
            // Store ouvert
            shopOpenHour.classList.add('shop-is-open');
            openTime.style.display = 'flex';
            closeTime.style.display = 'none';
            dot.style.background = 'var(--success)';

            // Afficher le téléphone
            if (telWrapper) telWrapper.style.display = 'flex';
            if (closedText) closedText.style.display = 'none';
        } else {
            // Store fermé
            shopOpenHour.classList.add('shop-is-close');
            openTime.style.display = 'none';
            closeTime.style.display = 'flex';
            dot.style.background = 'var(--primary)';

            // Cacher le téléphone et afficher le texte fermé
            if (telWrapper) {
                var telLink = telWrapper.querySelector('a');
                if (telLink) {
                    telLink.removeAttribute('href');
                    telLink.style.pointerEvents = 'none';
                }
                telWrapper.style.display = 'none';
            }
            if (closedText) closedText.style.display = 'block';
        }
    });
});

// Fonction globale pour le toggle des horaires (appelée via onclick)
function displayAllopeningHours(event) {
    console.log('🔘 displayAllopeningHours appelé');
    const shopHour = event.currentTarget;
    const weekHours = shopHour.nextElementSibling;

    console.log('Element shopHour:', shopHour);
    console.log('Element weekHours:', weekHours);

    if (weekHours) {
        shopHour.classList.toggle('active');

        if (weekHours.style.maxHeight) {
            weekHours.style.maxHeight = null;
        } else {
            weekHours.style.maxHeight = weekHours.scrollHeight + 'px';
        }
    } else {
        console.log('⚠️ weekHours est null');
    }
}
